var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAm = function SvgIconAm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M24 12c0-1.468-.264-2.874-.746-4.174L12 7.304.746 7.826A12 12 0 0 0 0 12c0 1.468.264 2.874.746 4.174L12 16.696l11.254-.522c.482-1.3.746-2.706.746-4.174"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9811",
    d: "M12 24c5.16 0 9.558-3.257 11.253-7.827H.746C2.442 20.743 6.84 24 12 24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M.746 7.826h22.507C21.558 3.256 17.16 0 12 0 6.84 0 2.442 3.257.746 7.826"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconAm;